import { useNavigate } from "react-router-dom";
import { TeamLogo } from "../shared/TeamLogo";

const getTeamName = (name) => {
  if (!name || name === "nan" || String(name).toLowerCase() === "nan" || String(name).trim() === "") {
    return "Non-NCAA team";
  }
  return name;
};

export const GameCard = ({ game }) => {
    const navigate = useNavigate();
    const hasPbp = !!game.has_pbp;
  
    const handleClick = () => {
      if (!hasPbp) return;
      navigate(`/games/${game.year}/${game.contest_id}`);
    };
  
    return (
      <div
        onClick={handleClick}
        className={`bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden transition-all duration-200
          ${hasPbp
            ? "cursor-pointer hover:shadow-md hover:border-blue-300"
            : "opacity-60 cursor-default"
          }`}
      >
        <div className="border-b border-gray-100 bg-gradient-to-r from-blue-50 to-blue-100 px-3 sm:px-4 py-2 flex items-center justify-between">
          <div className="text-xs sm:text-sm text-gray-600 truncate">
            {game.game_date}
          </div>
          {!hasPbp && (
            <span className="text-[10px] font-medium text-gray-400 uppercase tracking-wide">No PBP</span>
          )}
        </div>
  
        <div className="p-3 sm:p-4 space-y-3 sm:space-y-4">
          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2 sm:gap-3 flex-1 min-w-0">
                <TeamLogo teamId={game.away_team_id} teamName={getTeamName(game.away_team_name)} />
                <span className="font-medium truncate">{getTeamName(game.away_team_name)}</span>
              </div>
              <span className="font-mono font-bold ml-2">{game.away_score}</span>
            </div>
  
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2 sm:gap-3 flex-1 min-w-0">
                <TeamLogo teamId={game.home_team_id} teamName={getTeamName(game.home_team_name)} />
                <span className="font-medium truncate">{getTeamName(game.home_team_name)}</span>
              </div>
              <span className="font-mono font-bold ml-2">{game.home_score}</span>
            </div>
          </div>
  
          <div className="pt-2 sm:pt-3 border-t border-gray-100">
            <div className="flex items-center justify-between text-xs sm:text-sm">
              <div className="text-gray-600 truncate">Game #{game.contest_id}</div>
              <div className={`px-2 py-1 rounded-full text-xs font-medium ml-2 flex-shrink-0
                ${hasPbp ? "bg-gray-100 text-gray-700" : "bg-gray-50 text-gray-400"}`}>
                Final
              </div>
            </div>
          </div>
        </div>
      </div>
    );
};
